export default {
  intercom: false,
}